import { type FilterOptionType } from 'features/PricingEngine/components/SearchFilter'

import { CampaignFilterParamsType, CampaignRowType } from '../@types/campaignTypes'

/* eslint-disable sonarjs/no-duplicate-string */
export const TODO_STATUS = [
  {
    label: 'All',
    value: 'all',
  },
  {
    label: 'To Review',
    value: 'need_reviews',
  },
  {
    label: 'To Plan',
    value: 'need_plans',
  },
]

export type CampaignTableHeaderType = {
  value: keyof CampaignRowType
  label: string
  isShow: boolean
  minWidth: string
  sortable: boolean
  info: boolean
  id?: string
  group?: string
  groupId?: number
  sort_key?: string
  info_text?: string
  ellipsis?: boolean
  headerMaxWidth?: string
}

// Groups locked (disabled) in the column filter menu. Will be derived from the
// selected filter later; hardcoded for now.
export const CAMPAIGN_COLUMN_DISABLED_GROUP_IDS = [1, 5, 6, 8]

export const CAMPAIGN_TABLE_HEADERS: CampaignTableHeaderType[] = [
  {
    value: 'row_id',
    id: 'row_id',
    label: 'Row Id',
    isShow: true,
    minWidth: '125px',
    sortable: false,
    info: false,
    group: 'Product & Campaign',
    groupId: 1,
  },
  {
    value: 'product_name',
    id: 'product_name',
    label: 'Product',
    isShow: true,
    minWidth: '300px',
    sortable: false,
    info: false,
    group: 'Product & Campaign',
    groupId: 1,
  },
  {
    value: 'campaign_name',
    id: 'campaign_name',
    label: 'Campaign',
    isShow: true,
    minWidth: '250px',
    sortable: false,
    info: false,
    group: 'Product & Campaign',
    groupId: 1,
  },
  // CAMPAIGN ATTRIBUTES
  {
    value: 'campaign_type',
    id: 'campaign_type',
    label: 'Campaign Type',
    isShow: true,
    minWidth: '150px',
    sortable: false,
    info: false,
    group: 'Campaign Attribute',
    groupId: 2,
  },
  {
    value: 'payday_period',
    id: 'payday_period',
    label: 'Payday Period',
    isShow: true,
    minWidth: '150px',
    sortable: false,
    info: false,
    group: 'Campaign Attribute',
    groupId: 2,
  },
  {
    value: 'campaign_cluster',
    id: 'campaign_cluster',
    label: 'Campaign Cluster Adjusted',
    isShow: true,
    minWidth: '150px',
    sortable: false,
    info: false,
    group: 'Campaign Attribute',
    groupId: 2,
    ellipsis: true,
    headerMaxWidth: '130px',
  },
  // CAMPAIGN SETUP
  {
    value: 'normal_price',
    id: 'normal_price',
    label: 'Normal Price (Rp)',
    isShow: true,
    minWidth: '130px',
    sortable: true,
    sort_key: 'normal_price',
    info: false,
    group: 'Campaign Setup',
    groupId: 3,
    ellipsis: true,
    headerMaxWidth: '80px',
  },
  {
    value: 'discounted_price',
    id: 'discounted_price',
    label: 'Discounted Price (Rp)',
    isShow: true,
    minWidth: '130px',
    sortable: true,
    sort_key: 'discounted_price',
    info: false,
    group: 'Campaign Setup',
    groupId: 3,
    ellipsis: true,
    headerMaxWidth: '80px',
  },
  {
    value: 'daily_quota_adj',
    id: 'daily_quota_adj',
    label: 'Daily Quota Adjusted',
    isShow: true,
    minWidth: '100px',
    sortable: false,
    info: false,
    group: 'Campaign Setup',
    groupId: 3,
    ellipsis: true,
    headerMaxWidth: '80px',
  },
  {
    value: 'tier',
    id: 'tier',
    label: 'Tier',
    isShow: true,
    minWidth: '75px',
    sortable: false,
    info: false,
    group: 'Campaign Setup',
    groupId: 3,
  },
  {
    value: 'discount_pct',
    id: 'discount_pct',
    label: '% Disc',
    isShow: true,
    minWidth: '75px',
    sortable: false,
    info: false,
    group: 'Campaign Setup',
    groupId: 3,
  },
  // CAMPAIGN TIMELINE
  {
    value: 'campaign_start_date',
    id: 'campaign_start_date',
    label: 'Start Date',
    isShow: true,
    minWidth: '115px',
    sortable: false,
    info: false,
    group: 'Timeline',
    groupId: 4,
  },
  {
    value: 'campaign_end_date',
    id: 'campaign_end_date',
    label: 'End Date',
    isShow: true,
    minWidth: '115px',
    sortable: false,
    info: false,
    group: 'Timeline',
    groupId: 4,
  },
  {
    value: 'day_of_campaign',
    id: 'day_of_campaign',
    label: 'Days of Campaign',
    isShow: true,
    minWidth: '100px',
    sortable: false,
    info: false,
    group: 'Timeline',
    groupId: 4,
    ellipsis: true,
    headerMaxWidth: '80px',
  },
  {
    value: 'day_left_campaign',
    id: 'day_left_campaign',
    label: 'Num of Campaign Day Left',
    isShow: true,
    minWidth: '100px',
    sortable: false,
    info: false,
    group: 'Timeline',
    groupId: 4,
    ellipsis: true,
    headerMaxWidth: '80px',
  },
  // HISTORICAL SALES
  {
    value: 'avg_actual_swls_during_campaign',
    id: 'avg_actual_swls_during_campaign',
    label: 'During Campaign',
    isShow: true,
    minWidth: '130px',
    sortable: false,
    info: true,
    info_text: 'Avg SLS, exclude flush out',
    group: 'Historical Sales',
    groupId: 5,
    ellipsis: true,
    headerMaxWidth: '80px',
  },
  {
    value: 'avg_actual_swls_l30d',
    id: 'avg_actual_swls_l30d',
    label: 'L30D',
    isShow: true,
    minWidth: '130px',
    sortable: false,
    info: true,
    info_text: 'Avg SLS, exclude flush out',
    group: 'Historical Sales',
    groupId: 5,
    ellipsis: true,
    headerMaxWidth: '80px',
  },
  // FC Gap Analysis
  {
    value: 'gap_pcs_vs_actual_during_campaign',
    id: 'gap_pcs_vs_actual_during_campaign',
    label: 'Gap vs Actual During Campaign',
    isShow: true,
    minWidth: '130px',
    sortable: false,
    info: true,
    info_text: 'Gap pcs Current Campaign Forecast vs actual sales during campaign + loss',
    group: 'FC Gap Analysis',
    groupId: 6,
    ellipsis: true,
    headerMaxWidth: '80px',
  },
  {
    value: 'gap_pcs_vs_avg_l30d',
    id: 'gap_pcs_vs_avg_l30d',
    label: 'Gap vs Avg L30D',
    isShow: true,
    minWidth: '130px',
    sortable: false,
    info: true,
    info_text: 'Gap pcs Current Campaign Forecast vs avg L30D + loss (exclude flush out)',
    group: 'FC Gap Analysis',
    groupId: 6,
    ellipsis: true,
    headerMaxWidth: '80px',
  },
  {
    value: 'gap_pcs_vs_fc_layer3',
    id: 'gap_pcs_vs_fc_layer3',
    label: 'Gap vs Layer 3',
    isShow: true,
    minWidth: '130px',
    sortable: false,
    info: true,
    info_text: 'Gap pcs Current FC vs Layer 3',
    group: 'Gap pcs Current Campaign Forecast vs Layer 3',
    groupId: 6,
    ellipsis: true,
    headerMaxWidth: '80px',
  },
  // ADJUSTMENT NOTES
  {
    value: 'adj_remark_l3',
    id: 'adj_remark_l3',
    label: 'Adj Remark Layer 3',
    isShow: true,
    minWidth: '150px',
    sortable: false,
    info: false,
    group: 'Adjustment Notes',
    groupId: 7,
  },
  {
    value: 'adj_remark_l5',
    id: 'adj_remark_l5',
    label: 'Ajd Remark Layer 5',
    isShow: true,
    minWidth: '150px',
    sortable: false,
    info: false,
    group: 'Adjustment Notes',
    groupId: 7,
  },
  {
    value: 'remarks_hardcode',
    id: 'remarks_hardcode',
    label: 'Remarks Layer 4',
    isShow: true,
    minWidth: '150px',
    sortable: false,
    info: false,
    group: 'Adjustment Notes',
    groupId: 7,
  },
  // FINAL FORECAST
  {
    value: 'fc_layer3',
    id: 'fc_layer3',
    label: 'Forecast Layer 3',
    isShow: true,
    minWidth: '100px',
    sortable: false,
    info: false,
    group: 'Final Forecast',
    groupId: 8,
    ellipsis: true,
    headerMaxWidth: '80px',
  },
  {
    value: 'last_updated_at',
    id: 'last_updated_at',
    label: 'Last Updated At',
    isShow: true,
    minWidth: '150px',
    sortable: false,
    info: false,
    group: 'Final Forecast',
    groupId: 8,
  },
  {
    value: 'final_fc_layer4',
    id: 'final_fc_l4',
    label: 'Current Campaign Forecast',
    isShow: true,
    minWidth: '225px',
    sortable: false,
    info: false,
    group: 'Final Forecast',
    groupId: 8,
  },
  {
    value: 'campaign_status',
    id: 'campaign_status',
    label: 'Status',
    isShow: true,
    minWidth: '100px',
    sortable: false,
    info: false,
  },
]

export const ConditionOptions = [
  {
    label: 'less than',
    value: 'lt',
  },
  {
    label: 'less than or equal to',
    value: 'lte',
  },
  {
    label: 'more than',
    value: 'gt',
  },
  {
    label: 'more than or equal to',
    value: 'gte',
  },
  {
    label: 'equal to',
    value: 'eq',
  },
  {
    label: 'between',
    value: 'between',
  },
]

export const INITIAL_CAMPAIGN_FILTERS: CampaignFilterParamsType = {
  keyword: '',
  product_ids: '',
  product_names: '',
  campaign_names: '',
  skp_numbers: '',
  l1_category_ids: '',
  l2_category_ids: '',
  campaign_type: '',
  source_status: '',
  vendor_ids: '',
  brand_ids: '',
  business_line_keys: '',
  pic_emails: '',
  payday_period: '',
  category_demands: '',
  campaign_status: '',
  campaign_duration_op: '',
  campaign_duration_value: '',
  campaign_duration_value_to: '',
  disc_percent_op: '',
  disc_percent_value: '',
  disc_percent_value_to: '',
  final_fc_status: '',
  actions: 'need_reviews',
  sort_by: 'row_id',
  sort_direction: 'asc',
  cursor: '',
  page_size: 100,
}

export const CAMPAIGN_FILTER_STORAGE_KEY = 'scms_campaign_filters'

export const HISTORY_OPTIONS = ['Last 30 days', 'Last 60 days', 'Last 90 days', 'Custom Range']

export const SEARCH_FILTER_OPTIONS: FilterOptionType[] = [
  { value: 'product_ids', label: 'Product Id', placeholder: 'Search Product Ids' },
  { value: 'product_names', label: 'Product Name', placeholder: 'Search Product Names' },
  { value: 'keyword', label: 'Row Id', placeholder: 'Search Row Id' },
  { value: 'campaign_names', label: 'Campaign Name', placeholder: 'Search Campaign Names' },
  { value: 'skp_numbers', label: 'SKP Number', placeholder: 'Search SKP Number' },
]
